import { ResourceMapperNotificationTypes } from '../types';
import i18n from 'i18next';

export const generateIgnoreMessage = (successes: any[], startingDescription: string) => ({
  note_type: successes.length
    ? ResourceMapperNotificationTypes.PATCH_SUCCESS
    : ResourceMapperNotificationTypes.PATCH_FAIL,
  note: {
    message: i18n.t('resource_mapper.notifications.not_mapped', { startingDescription }),
    description: i18n.t('resource_mapper.notifications.instances_were_ignored', {
      count: successes.length,
    }),
    type: 'SUCCESS',
  },
});
